import { Component, ComponentFactoryResolver, ComponentRef, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { Configuration, Encrypted } from 'src/app/Constants/configuration';
import { CocheSeguro } from 'src/app/modelos/cocheSeguro.model';
import { RequestServices } from 'src/app/services/request.service';
import { StorageService } from 'src/app/services/storage.service';
import { ContainerProcessDirective } from 'src/app/tools/directives/container-process.directive';
import { AprobacionCancelacionComponent } from '../../components/proceso-cancelacion/aprobacion-cancelacion/aprobacion-cancelacion.component';
import { DatosCancelacionComponent } from '../../components/proceso-cancelacion/datos-cancelacion/datos-cancelacion.component';
import { FirmaCancelacionComponent } from '../../components/proceso-cancelacion/firma-cancelacion/firma-cancelacion.component';
import { InicioCancelacionComponent } from '../../components/proceso-cancelacion/inicio-cancelacion/inicio-cancelacion.component';
import { DatosRecibos, PolizaCreacion  } from '../../../modelos/poliza-creacion.model';
import { throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

interface Cancelacion {
  idAnverso: any;
  idReverso: any;
  comprobanteDomicilio: any;
  firma: string;
  noSerie?: string;
  ciaId?: number;
  nombreCliente?: string;
  clienteId?: string;
  ciaNombre?: string;
}

interface Aseguradora {
  cia: number;
  nombre: string;
}

@Component({
  selector: 'app-cancelacion-poliza',
  templateUrl: './cancelacion-poliza.component.html',
  styleUrls: ['./cancelacion-poliza.component.css']
})
export class CancelacionPolizaComponent implements OnInit, OnDestroy {

  @ViewChild(ContainerProcessDirective, {static: true})containerProcess: ContainerProcessDirective;
  public currentStep: number;
  public labelCurrentStep: string;
  public noSerie: string;
  public isLoading: boolean = false;
  public datosCancelacion: Cancelacion;
  private subscriptions: Subscription;  
  private cocheSeguro;
  private prospecto;
  private contratante;
  private polizaCreacion: PolizaCreacion = new PolizaCreacion();
  private cotizacionId;
  private vehiculo;
  private conductor;
  private valorEncriptado;
  private polizaId;
  private polizaIdEnc;
  private cancel:any = {};
  private cliId;

  public const: Configuration = new Configuration();

  aseguradoras: Aseguradora[] = [
    {
      cia: 29,
      nombre: 'QUALITAS COMPAÑIA DE SEGUROS S.A. DE C.V.'
    },
    {
      cia: 31,
      nombre: 'SEGUROS AFIRME S.A. DE C.V.'
    },
    {
      cia: 49,
      nombre: 'PRIMERO SEGUROS S. A. DE C. V.'
    },
    {
      cia: 14,
      nombre: 'HDI SEGUROS S. A. DE C. V.'
    },
    {
      cia: 18,
      nombre: 'GRUPO NACIONAL PROVINCIAL S.A.B.'
    },
    {
      cia: 1,
      nombre: 'CHUBB SEGUROS MÉXICO, S.A.'
    },
    {
      cia: 22,
      nombre: 'MAPFRE MÉXICO, S.A.'
    }
  ]

  constructor(private componentFactoryResolver: ComponentFactoryResolver, 
        private dialogRef : MatDialogRef<CancelacionPolizaComponent>,
        private storageService: StorageService,
        private requestService: RequestServices,
        private router: Router,
        private snackBar: MatSnackBar) { 
    this.currentStep = 0;
    this.datosCancelacion = null;
    this.labelCurrentStep = 'INICIAR PROCESO'
    this.isLoading = false;
  }

  ngOnInit(): void {
    this.componentLoader(InicioCancelacionComponent);
    this.initDataCancelacion();
  }

  toFinish() {    
    this.isLoading = true;
    let dataCliente = this.generaDatosCliente();
    this.requestService.postRequest({apiName: 'InterAutosDatosContratanteApi', dataJSON: dataCliente }).pipe(
      switchMap((creacionRes:any) => {
        if(creacionRes.error)  {
          return throwError(creacionRes.error);
        } else {
          this.polizaCreacion.t1.vnd = creacionRes.vnd;
          this.polizaCreacion.t1.cli = creacionRes.cte;
          this.polizaCreacion.t1.dcl = creacionRes.dcl;          
          this.cocheSeguro.tkn = creacionRes.token;
          this.cocheSeguro.m = creacionRes.m;
          this.cocheSeguro.clEnt = creacionRes.clEnt;
          this.cliId = creacionRes.cte;
          this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
          return this.requestService.getRequest({ projectName: new Configuration().URLUTILERIAS,
            apiName: 'inter/autos/busqueda-poliza',
            params: {
              noSerie: this.vehiculo.serie,
              ciaId: this.cocheSeguro.cia
            }});
        }
      })
    ).subscribe(res => {
      if("polizaId" in res) {
        this.polizaId = res.polizaId;
        this.polizaIdEnc = res.polizaIdEnc;
        if(res.clienteId == this.cliId) {
         this.startCancel();
        } else {
          this.dialogRef.close();
          this.snackBar.open("La poliza esta asociada a otro cliente", "", { duration: this.const.SNACK_BARTIME })
        }
      } else {
         this.startCancelPoliza();
      }
      //this.startCancelPoliza();
   });
  }
  
  startCancel() {
    let formData:FormData =  this.generaDatosCancelacion();
    this.generaDatosEndoso();
    this.requestService.postRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "MarketCancelacionAutoAPI", dataJSON: this.cancel }).subscribe(canRes => {
      if(canRes.error) {
        console.error(canRes);
      } else {
        console.log(canRes);
      }      
    });

    this.requestService.uploadFileAdjuntos(new Configuration().URLUTILERIAS, 'inter/autos/cancelacion-poliza', formData).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe(res => {
     console.log(res);
     this.dialogRef.close();
     this.router.navigate(['cotizacion']);
    }, error => {
     console.error(error);
     this.dialogRef.close();
     this.snackBar.open("Error al subir los documentos", "", { duration: this.const.SNACK_BARTIME });
    });
  }
  
  startCancelPoliza() {
    this.isLoading = true;
    this.requestService.getRequest({ projectName: new Configuration().URLPOLIZAS, apiName: "WorkSiteEncryptAPI", params: [{ "f1": this.cocheSeguro.cia}]})
      .pipe(switchMap((resEnc:any) => {
        if (resEnc.error) {
          return throwError(resEnc.error);
        } else {
          this.valorEncriptado = resEnc.c1;
          return this.requestService.getRequest({projectName: new Configuration().URLPOLIZAS,
               apiName: 'WorksiteParametroByArrParametroStrAPI',
               params: [{ 'f1': "76, 106" }, { 'f2': 3 }, { 'f3': this.valorEncriptado}]});
        }
      }),switchMap((resWork:any) => {
        if(resWork.error) {
          return throwError(resWork.error);
        } else {
          for (let objParam of resWork) {
            switch (objParam.tipo) {
              case 76:
                this.polizaCreacion.t1.agc = JSON.parse(objParam.valorStr).age;
                this.polizaCreacion.t1.vnd = JSON.parse(objParam.valorStr).vendedor;
                break;
            }
          }
          this.generaDatosPoliza();
          return this.requestService.postRequest({ projectName: new Configuration().URLPOLIZALAZY,
             apiName: 'Sio4PolizaCreacionAPI',
             dataJSON: this.polizaCreacion });
        }        
      })).subscribe(resPoliza => {
        if(resPoliza.poid) {
          this.polizaId = resPoliza.poid;
          this.polizaIdEnc = resPoliza.id;
          this.startCancel(); 
        } else if(resPoliza.error) {
          console.error(resPoliza.error);
          this.snackBar.open(resPoliza.error, "", { duration: this.const.SNACK_BARTIME });
        }
      }, error => {
        console.error(error);
        this.snackBar.open("Error en proceso de cancelacion", "", { duration: this.const.SNACK_BARTIME });
      });            
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  nextStep() {
    switch(this.currentStep) {
      case 0:
        this.componentLoader(AprobacionCancelacionComponent);
        this.currentStep = 1;
        this.labelCurrentStep = 'PROCEDER AL PASO 2';
        break;
      case 1: 
      this.subscriptions = this.componentLoader(DatosCancelacionComponent).instance.event.subscribe(res => {
          this.datosCancelacion = {
            ...res
          }
        });
        this.currentStep = 2;
        this.labelCurrentStep = 'PROCEDER AL PASO 3';
        break;
      case 2:         
        this.dialogRef.updateSize('400px');
        this.subscriptions.add(this.componentLoader(FirmaCancelacionComponent).instance.eventFirm.subscribe(res => {
          this.datosCancelacion = {
            ...this.datosCancelacion,
            ...res
          }
        }));
        this.currentStep = 3;
        break;
    }
  }

  backStep() {
    switch(this.currentStep) {
      case 1: 
        this.componentLoader(InicioCancelacionComponent);
        this.currentStep = 0;
        this.labelCurrentStep = 'INICIAR PROCESO';
        break;
      case 2: 
      this.componentLoader(AprobacionCancelacionComponent);
        this.currentStep = 1;
        this.labelCurrentStep = 'PROCEDER AL PASO 2';
        break;
      case 3:
        this.dialogRef.updateSize('311px');
        this.componentLoader(DatosCancelacionComponent);
        this.currentStep = 2;
        this.labelCurrentStep = 'PROCEDER AL PASO 3';
      default: 
        break;
    }
  }

  initDataCancelacion() {
    if (this.storageService.ifExist("cocheSeguro")) {
      this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
      this.prospecto = this.cocheSeguro.prospecto;
      this.contratante = this.cocheSeguro.contratante;
      this.vehiculo =  this.cocheSeguro.vehiculo;
      this.cotizacionId  = this.cocheSeguro.cot_id;
      this.conductor = this.cocheSeguro.conductor;
    }
    
  }

  generaDatosCancelacion() {       
    if(this.storageService.ifExist('cocheSeguro')) {
      const cocheSeguro: CocheSeguro = JSON.parse(this.storageService.getItem('cocheSeguro'));
      const formData = new FormData();
      this.datosCancelacion = { 
        ...this.datosCancelacion,
        ciaId: cocheSeguro.cia,
        noSerie: this.noSerie,
        nombreCliente: `${cocheSeguro.contratante.nombres} ${cocheSeguro.contratante.ap_pat} ${cocheSeguro.contratante.ap_mat}`,
        ciaNombre: this.aseguradoras.find((a: Aseguradora) => a.cia === cocheSeguro.cia).nombre
      }

      if(cocheSeguro?.clEnt) {
        this.datosCancelacion.clienteId = cocheSeguro.clEntInt;
        formData.append('clienteId', this.datosCancelacion.clienteId);
      }

      formData.append('firma', this.base64ToBlob(this.datosCancelacion.firma));

      formData.append('idAnverso', this.datosCancelacion.idAnverso);
      formData.append('idReverso', this.datosCancelacion.idReverso);
      formData.append('comprobanteDomicilio', this.datosCancelacion.comprobanteDomicilio);
      formData.append('nombreCliente', this.datosCancelacion.nombreCliente);

      if(this.datosCancelacion.clienteId != undefined && this.datosCancelacion.clienteId != null)
          formData.append('clienteId', this.datosCancelacion.clienteId);
      
      formData.append('ciaId', this.datosCancelacion.ciaId.toString());
      formData.append('ciaNombre', this.datosCancelacion.ciaNombre);
      formData.append('noSerie', this.datosCancelacion.noSerie);
      formData.append('polizaId', this.polizaId);
      formData.append('vehiculoDesc', this.cocheSeguro.dataVehiculo.datosAuto.descripcion);
      formData.append('s4_key', new Configuration().S4_KEY);      
      formData.append('b', cocheSeguro.m);
      return formData;
    }    
  }

  private generaDatosCliente() {

    let dataCliente = {
      "correo": this.prospecto.correo,
      "pass": this.prospecto.contrasena,
      "grupo_id": this.cocheSeguro.grupoID,
      "peem_id": 0,
      "nombres": this.contratante.nombres,
      "ap_pat": this.contratante.ap_pat,
      "ap_mat": this.contratante.ap_mat,
      "fec_nac": this.contratante.fec_nac_str,
      "rfc": this.contratante.rfc,
      "sexo": (this.contratante.sexo === "M") ? 1 : 0,
      "celular": this.cocheSeguro?.celular,
      "telefono": this.cocheSeguro?.telefono,
      "direccion": this.contratante.direccion.calle,
      "num_ext": this.contratante.direccion.no_ext,
      "num_int": this.contratante.direccion.no_int,
      "cp": this.contratante.direccion.cp,
      "colonia": this.contratante.direccion.col,
      "a": this.cocheSeguro?.a
    }
    return dataCliente;
  }

  generaDatosPoliza() {

    let fechaActual = this.generaFecha();
    let fechaVigFin = this.generaFecha(1);
    
    /**Datos póliza */
    this.polizaCreacion.t1.cotId = this.cotizacionId;
    this.polizaCreacion.t1.emiId = 0;
    this.polizaCreacion.t1.negId = 0;
    this.polizaCreacion.t1.cia = this.cocheSeguro.cia;//Setting cia
    this.polizaCreacion.t1.ram = 1;
    this.polizaCreacion.t1.sbr = 1;

    /**INTERPROTECCION AGENTE DE SEGUROS => 78299 */    
    this.polizaCreacion.t1.mon = 1;
    this.polizaCreacion.t1.fpa = 1;
    this.polizaCreacion.t1.fco = 0;
    this.polizaCreacion.t1.npo = this.generaNombrePoliza();
    this.polizaCreacion.t1.inc = 1;
    this.polizaCreacion.t1.con = "Poliza para seguimiento de cancelacion";
    this.polizaCreacion.t1.pri = 0.0;
    this.polizaCreacion.t1.der = 0.0;
    this.polizaCreacion.t1.rcg = 0.0;
    this.polizaCreacion.t1.iva = 0.0;
    this.polizaCreacion.t1.tot = 0.0;
    this.polizaCreacion.t1.fem = fechaActual;
    this.polizaCreacion.t1.fvd = fechaActual;
    this.polizaCreacion.t1.fva = fechaVigFin;
    this.polizaCreacion.t1.fcr = fechaActual;
    this.polizaCreacion.t1.ref = '';

    if (this.cocheSeguro.cia == 18) {
      this.polizaCreacion.t1.status = 1;
    }

    let recibo: DatosRecibos = new DatosRecibos();
    recibo.ser = 1; // serie
    recibo.tse = 1; // total serie
    recibo.pri = 0.00; // prima
    recibo.aj1 = 0.00; // ajuste1
    recibo.aj2 = 0.00; // ajuste2
    recibo.cxt = 0.00; // cargo extra
    recibo.der = 0.00; // derecho
    recibo.rcg = 0.00; // recargo
    recibo.iva = 0.00;
    recibo.tot = 0.00; // total
    recibo.com = 0.00; // comision
    recibo.fvd = fechaActual;// fecha vigencia de
    recibo.fva = fechaActual;// fecha vigencia a
    recibo.fvn = fechaVigFin;// fecha vence
    recibo.fcr = fechaActual;// fecha creacion
    this.polizaCreacion.t2.push(recibo);
    this.polizaCreacion.t3.push({ gpo: this.cocheSeguro.grupoID, pal: true });

    /**Datos Vehículo */
    this.polizaCreacion.t5.nse = this.vehiculo.serie;
    //this.polizaCreacion.t5.ami = this.dataEmision.cve;
    this.polizaCreacion.t5.dsc = this.cocheSeguro.dataVehiculo.datosAuto.descripcion;
    this.polizaCreacion.t5.mdl = 0;
    this.polizaCreacion.t5.nmb = this.conductor.nombres;
    this.polizaCreacion.t5.app = this.conductor.ap_pat;
    this.polizaCreacion.t5.apm = this.conductor.ap_mat;
    if (this.contratante.sexo == 'M') {
      this.polizaCreacion.t5.sex = true;
    } else {
      this.polizaCreacion.t5.sex = false;
    }
    this.polizaCreacion.t5.fnc = this.conductor.fec_nac_str != '' ? this.conductor.fec_nac_str : this.contratante.fec_nac_str;
    //this.polizaCreacion.t5.crr = ((this.dataEmision.contratante.correos.length > 0) ? this.dataEmision.contratante.correos[0].correo : "");
    //this.polizaCreacion.t5.cel = ((this.dataEmision.contratante.celular.length > 0) ? this.dataEmision.contratante.celular[0].num_tel : "");
    this.polizaCreacion.t5.rfc = this.conductor.rfc;
    this.polizaCreacion.t5.dir = `${this.contratante.direccion.calle} ${this.contratante.direccion.no_ext}`;
    this.polizaCreacion.t5.cpi = this.contratante.direccion.cp;
    this.polizaCreacion.t5.col = this.contratante.direccion.col
    this.polizaCreacion.t5.eda = this.cocheSeguro.edad;
    /**Aquí irá nómina */
    //this.polizaCreacion.t5.nom = this.conductor.ref ? this.conductor.ref : '';
    this.polizaCreacion.t5.plc = this.vehiculo.placas;
    this.polizaCreacion.t5.edo = this.contratante.direccion.estado;
    //this.polizaCreacion.t5.uso = this.dataEmision.52;
    //this.polizaCreacion.t5.servicio = this.dataEmision.servicio;4

    this.polizaCreacion.t6.ramoId = new Encrypted().UNO;
    this.polizaCreacion.t6.aseguradoraId = this.valorEncriptado;
    this.polizaCreacion.t6.paqueteId = new Encrypted().ZERO;
    this.polizaCreacion.t6.coberturas = [];
    /**URL para ejecución de guardado de coberturas */5
    this.polizaCreacion.t7 = (new Configuration().URLPOLIZAS.includes('8181') ? new Configuration().URLPOLIZAS.replace(':8181', ':8080').replace('https', 'http') : new Configuration().URLPOLIZAS);
    // console.log("Poliza creacion");
    // console.log(this.polizaCreacion);
    // console.log(JSON.stringify(this.polizaCreacion));
  }

  generaDatosEndoso() {    
    this.cancel.polizaId = this.polizaIdEnc;
    this.cancel.razon = "Cancelación por solicitud de cliente";
    this.cancel.motivo = "Cancelación por solicitud del cliente";
    this.cancel.aplicarEndoso = true;
    this.cancel.opcion = 3;
    this.cancel.status = 1;
    this.cancel.movimiento = 9;  
    //console.log(this.cancel);
  }

  private base64ToBlob(base64: string) {
    const parts = base64.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: imageType });
  }


  onClose() {
    this.dialogRef.close();
  }

  private componentLoader<T>(component: Type<T>): ComponentRef<T> {

    const componentProcessCancelFactory = 
      this.componentFactoryResolver.resolveComponentFactory<T>(component);
    const viewContainerRef = this.containerProcess.viewContainerRef;
    viewContainerRef.clear();
    return viewContainerRef.createComponent<T>(componentProcessCancelFactory);

  }

  generaFecha(anios?:number): string {

    let d: Date = new Date();
    let mes;
    let day = (d.getDate().toString().length == 1 ? '0' + d.getDate() : d.getDate());
    let year = anios ? d.getFullYear() + anios: d.getFullYear();

    if ((d.getMonth() + 1).toString().length == 1) {
      mes = '0' + (d.getMonth() + 1);
    } else {
      mes = (d.getMonth() + 1);
    }
    return `${year}-${mes}-${day} 00:00:00`;
  }

  generaNombrePoliza() {
    let d: Date = new Date();
    let mes;
    let day = (d.getDate().toString().length == 1 ? '0' + d.getDate() : d.getDate());
    let year = d.getFullYear();
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let seconds = d.getSeconds();
    if ((d.getMonth() + 1).toString().length == 1) {
      mes = '0' + (d.getMonth() + 1);
    } else {
      mes = (d.getMonth() + 1);
    }

    return  `INTERCan_${year}${mes}${day}${hours}${minutes}${seconds}`;
  }

}
